import { AccountAside } from '@src/components/sco/Account/Layout/AccountAside';
import { AccountLayout } from '@src/components/sco/Account/Layout/AccountLayout';
import React from 'react';
export const AccountPage = Component => {
  Component.getLayout = (page: React.ReactElement) => {
    return <AccountLayout asidePanel={<AccountAside />} mainPanel={page} />;
  };
  return Component;
};